import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { JetcoService } from '../../services/jetco.service';

@Injectable()
export class JetcoClaimAmountEffects {
  constructor(private store: Store<any>,
    private actions$: Actions,
    private service: JetcoService) {
  }

  getData$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestAction),
    switchMap((action: any) => this.service.jetcoClaimAmount(action.start, action.end)),
    map((data: any) => {
      return ActionsList.ResponseAction({ payload: data.data });
    })
  ));

}
